var exports = {
  "q": "fadeIn__jy-Z33",
  "S": "AnimatedAnnotationIcon__GK2BSU",
};

module.exports = exports;
